import { connect } from 'react-redux';

import { IState } from '../../store';
import { isAbExperiment } from '../../utils/isAbExperiment';
import { IABCallButtonProps, ABCallButtonComponent } from './component';

export function mapStateToProps(state: IState): IABCallButtonProps {
    const {
        pageData: {
            dealType,
            offerType,
        },
        offerData: {
            offer: {
                isFromBuilder,
            },
        },
    } = state;

    return {
        isCallButtonExperimentActive: isAbExperiment(state.experiments, 'call_button_name_offer'),
        isFromBuilder: dealType === 'sale' && offerType === 'flat' && Boolean(isFromBuilder),
    };
}

export const ABCallButton = connect(
    mapStateToProps,
)(ABCallButtonComponent);
